/** @flow */

export const SetClient = "RECORDING/SET_CLIENT";
export const SetSettings = "RECORDING/SET_SETTINGS";
export const SetEmployee = "RECORDING/SET_EMPLOYEE";
export const SetEmployeeSchema = "RECORDING/SET_EMPLOYEE_SCHEMA";
export const SetWillingToTriage = "RECORDING/SET_WILLING_TRIAGE";

export const GetEmployeeSchema = "RECORDING/GET_EMPLOYEE_SCHEMA";
export const GetEmployeeSchemaSuccess = "RECORDING/GET_EMPLOYEE_SCHEMA_SUCCESS";
export const GetEmployeeSchemaError = "RECORDING/GET_EMPLOYEE_SCHEMA_ERROR";

export const GetInteractionNotesSchema = "RECORDING/GET_INTERACTION_NOTES_SCHEMA";
export const GetInteractionNotesSchemaSuccess = "RECORDING/GET_INTERACTION_NOTES_SCHEMA_SUCCESS";
export const GetInteractionNotesSchemaError = "RECORDING/GET_INTERACTION_NOTES_SCHEMA_ERROR";

export const ResetAbsenceRecording = "RESET_ABSENCE_RECORDING";
export const GetAbsenceRecordingConfig = "GET_ABSENCE_RECORDING_CONFIG";
export const GetAbsenceRecordingConfigSuccess = "GET_ABSENCE_RECORDING_CONFIG_SUCCESS";
export const GetAbsenceRecordingConfigError = "GET_ABSENCE_RECORDING_CONFIG_ERROR";
export const SetAbsenceRecordingWizardState = "SET_ABSENCE_RECORDING_WIZARD_STATE";
export const AcceptNurseCallback = "ACCEPT_NURSE_CALLBACK";
export const AcceptNurseCallbackSuccess = "ACCEPT_NURSE_CALLBACK_SUCCESS";
export const AcceptNurseCallbackError = "ACCEPT_NURSE_CALLBACK_ERROR";
export const AssignCallbackLanding = "ASSIGN_CALLBACK_LANDING";
export const AssignCallbackLandingSuccess = "ASSIGN_CALLBACK_LANDING_SUCCESS";
export const AssignCallbackLandingError = "ASSIGN_CALLBACK_LANDING_ERROR";
export const GetCallbackQueues = "GET_CALLBACK_QUEUES";
export const GetCallbackQueuesSuccess = "GET_CALLBACK_QUEUES_SUCCESS";
export const GetCallbackQueuesError = "GET_CALLBACK_QUEUES_ERROR";
export const SelectNextCallback = "SELECT_NEXT_CALLBACK";
export const SelectNextCallbackSuccess = "SELECT_NEXT_CALLBACK_SUCCESS";
export const SelectNextCallbackError = "SELECT_NEXT_CALLBACK_ERROR";
export const CloseNextCallbackModal = "CLOSE_NEXT_CALLBACK_MODAL";
export const UpdateCallback = "UPDATE_CALLBACK";
export const UpdateCallbackSuccess = "UPDATE_CALLBACK_SUCCESS";
export const UpdateCallbackError = "UPDATE_CALLBACK_ERROR";
export const ToggleIncomingCallModal = "TOGGLE_INCOMING_CALL_MODAL";
export const ToggleNurseTransferModal = "TOGGLE_NURSE_TRANSFER_MODAL";
export const ToggleNurseCallbackModal = "TOGGLE_NURSE_CALLBACK_MODAL";
export const CreateMedicalAdviceCallback = "CREATE_MEDICAL_ADVICE_CALLBACK";
export const CreateMedicalAdviceCallbackSuccess = "CREATE_MEDICAL_ADVICE_CALLBACK_SUCCESS";
export const CreateMedicalAdviceCallbackError = "CREATE_MEDICAL_ADVICE_CALLBACK_ERROR";

export const CreateCallInteraction = "CREATE_CALL_INTERACTION";
export const CreateCallInteractionSuccess = "CREATE_CALL_INTERACTION_SUCCESS";
export const CreateCallInteractionError = "CREATE_CALL_INTERACTION_ERROR";
export const GetCallInteraction = "GET_CALL_INTERACTION";
export const GetCallInteractionSuccess = "GET_CALL_INTERACTION_SUCCESS";
export const GetCallInteractionError = "GET_CALL_INTERACTION_ERROR";

export const GetCallbackScript = "GET_CALLBACK_SCRIPT";
export const GetCallbackScriptSuccess = "GET_CALLBACK_SCRIPT_SUCCESS";
export const GetCallbackScriptError = "GET_CALLBACK_SCRIPT_ERROR";
export const UpdateCallInteraction = "UPDATE_CALL_INTERACTION";
export const UpdateCallInteractionSuccess = "UPDATE_CALL_INTERACTION_SUCCESS";
export const UpdateCallInteractionError = "UPDATE_CALL_INTERACTION_ERROR";
export const SearchEmployees = "SEARCH_EMPLOYEES";
export const SearchEmployeesSuccess = "SEARCH_EMPLOYEES_SUCCESS";
export const SearchEmployeesError = "SEARCH_EMPLOYEES_ERROR";
export const SubmitCurrentStep = "SUBMIT_CURRENT_STEP";
export const SetDefaultWizardStep = "SET_DEFAULT_WIZARD_STEP";
export const SelectClient = "ABSENCE_RECORDING_SELECT_CLIENT";
export const SelectClientSuccess = "ABSENCE_RECORDING_SELECT_CLIENT_SUCCESS";
export const AbsenceRecordingSelectEmployee = "ABSENCE_RECORDING_SELECT_EMPLOYEE";
export const SetCallPurpose = "SET_CALL_PURPOSE";
export const SetCallPurposeSuccess = "SET_CALL_PURPOSE_SUCCESS";
export const SetClientSettings = "SET_CLIENT_SETTINGS";
export const SetAutoIdData = "SET_AUTO_ID_DATA";
export const SetAutoIdDataPrefilled = "SET_AUTO_ID_DATA_PREFILLED";
export const GetPreselectedEmployee = "GET_PRESELECTED_EMPLOYEE";
export const GetPreselectedEmployeeSuccess = "GET_PRESELECTED_EMPLOYEE_SUCCESS";
export const GetPreselectedEmployeeError = "GET_PRESELECTED_EMPLOYEE_ERROR";
export const GetEmployeeAbsenceRecording = "GET_EMPLOYEE_ABSENCE_RECORDING";
export const GetEmployeeAbsenceRecordingSuccess = "GET_EMPLOYEE_ABSENCE_RECORDING_SUCCESS";
export const GetEmployeeAbsenceRecordingError = "GET_EMPLOYEE_ABSENCE_RECORDING_ERROR";

export const GetEmployeeAbsenceRecordingWellbeingService =
  "GET_EMPLOYEE_ABSENCE_RECORDING_WELLBEING_SERVICE";
export const GetEmployeeAbsenceRecordingWellbeingServiceSuccess =
  "GET_EMPLOYEE_ABSENCE_RECORDING_WELLBEING_SERVICE_SUCCESS";
export const GetEmployeeAbsenceRecordingWellbeingServiceError =
  "GET_EMPLOYEE_ABSENCE_RECORDING_WELLBEING_SERVICE_ERROR";
export const UpdateRecordingAccessLevelSuccess = "UPDATE_RECORDING_ACCESS_LEVEL_SUCCESS";
export const AssignAbsenceLanding = "ASSIGN_ABSENCE_LANDING";
export const AssignAbsenceLandingSuccess = "ASSIGN_ABSENCE_LANDING_SUCCESS";
export const AssignAbsenceLandingError = "ASSIGN_ABSENCE_LANDING_ERROR";
export const CancelCallInteraction = "CANCEL_CALL_INTERACTION";
export const CancelCallInteractionSuccess = "CANCEL_CALL_INTERACTION_SUCCESS";
export const CancelCallInteractionError = "CANCEL_CALL_INTERACTION_ERROR";
export const ConfirmCallInteraction = "CONFIRM_CALL_INTERACTION";
export const ConfirmCallInteractionSuccess = "CONFIRM_CALL_INTERACTION_SUCCESS";
export const ConfirmCallInteractionError = "CONFIRM_CALL_INTERACTION_ERROR";
export const SetInteractionType = "SET_INTERACTION_TYPE";
export const SetCloseAbsenceOverride = "SET_CLOSE_ABSENCE_OVERRIDE";
export const SetCallInteractionAbsence = "SET_CALL_INTERACTION_ABSENCE";
export const ToggleEmployeeRecordSidebar = "TOGGLE_EMPLOYEE_RECORD_SIDEBAR";
export const SetEmployeeRecordNotifications = "SET_EMPLOYEE_RECORD_NOTIFICATIONS";
export const ToggleEmployeeAbsenceInteractionsModal = "TOGGLE_EMPLOYEE_ABSENCE_INTERACTIONS_MODAL";
export const SetReasonAndDurationFormData = "SET_REASON_AND_DURATION_FORM_DATA";
export const SetReasonAndDuration = "SET_REASON_AND_DURATION";

// Medical Triage
export const CreateMedicalTriage = "CREATE_MEDICAL_TRIAGE";
export const CreateMedicalTriageSuccess = "CREATE_MEDICAL_TRIAGE_SUCCESS";
export const CreateMedicalTriageError = "CREATE_MEDICAL_TRIAGE_ERROR";
export const UpdateMedicalTriage = "UPDATE_MEDICAL_TRIAGE";
export const UpdateMedicalTriageSuccess = "UPDATE_MEDICAL_TRIAGE_SUCCESS";
export const UpdateMedicalTriageError = "UPDATE_MEDICAL_TRIAGE_ERROR";

export const AssignLifestyleChoices = "ASSIGN_LIFESTYLE_CHOICES";
export const AssignLifestyleChoicesSuccess = "ASSIGN_LIFESTYLE_CHOICES_SUCCESS";
export const AssignLifestyleChoicesError = "ASSIGN_LIFESTYLE_CHOICES_ERROR";

export const GetPastMedicalHistory = "GET_PAST_MEDICAL_HISTORY";
export const GetPastMedicalHistorySuccess = "GET_PAST_MEDICAL_HISTORY_SUCCESS";
export const GetPastMedicalHistoryError = "GET_PAST_MEDICAL_HISTORY_ERROR";
export const UpdatePastMedicalHistory = "UPDATE_PAST_MEDICAL_HISTORY";
export const UpdatePastMedicalHistorySuccess = "UPDATE_PAST_MEDICAL_HISTORY_SUCCESS";
export const UpdatePastMedicalHistoryError = "UPDATE_PAST_MEDICAL_HISTORY_ERROR";
export const CreatePastMedicalHistory = "CREATE_PAST_MEDICAL_HISTORY";
export const CreatePastMedicalHistorySuccess = "CREATE_PAST_MEDICAL_HISTORY_SUCCESS";
export const CreatePastMedicalHistoryError = "CREATE_PAST_MEDICAL_HISTORY_ERROR";
export const DeletePastMedicalHistory = "DELETE_PAST_MEDICAL_HISTORY";
export const DeletePastMedicalHistorySuccess = "DELETE_PAST_MEDICAL_HISTORY_SUCCESS";
export const DeletePastMedicalHistoryError = "DELETE_PAST_MEDICAL_HISTORY_ERROR";

export const GetCurrentMedications = "GET_CURRENT_MEDICATIONS";
export const GetCurrentMedicationsSuccess = "GET_CURRENT_MEDICATIONS_SUCCESS";
export const GetCurrentMedicationsError = "GET_CURRENT_MEDICATIONS_ERROR";
export const UpdateCurrentMedications = "UPDATE_CURRENT_MEDICATIONS";
export const UpdateCurrentMedicationsSuccess = "UPDATE_CURRENT_MEDICATIONS_SUCCESS";
export const UpdateCurrentMedicationsError = "UPDATE_CURRENT_MEDICATIONS_ERROR";
export const CreateCurrentMedications = "CREATE_CURRENT_MEDICATIONS";
export const CreateCurrentMedicationsSuccess = "CREATE_CURRENT_MEDICATIONS_SUCCESS";
export const CreateCurrentMedicationsError = "CREATE_CURRENT_MEDICATIONS_ERROR";
export const DeleteCurrentMedications = "DELETE_CURRENT_MEDICATIONS";
export const DeleteCurrentMedicationsSuccess = "DELETE_CURRENT_MEDICATIONS_SUCCESS";
export const DeleteCurrentMedicationsError = "DELETE_CURRENT_MEDICATIONS_ERROR";

export const GetCurrentAllergies = "GET_CURRENT_ALLERGIES";
export const GetCurrentAllergiesSuccess = "GET_CURRENT_ALLERGIES_SUCCESS";
export const GetCurrentAllergiesError = "GET_CURRENT_ALLERGIES_ERROR";
export const UpdateCurrentAllergies = "UPDATE_CURRENT_ALLERGIES";
export const UpdateCurrentAllergiesSuccess = "UPDATE_CURRENT_ALLERGIES_SUCCESS";
export const UpdateCurrentAllergiesError = "UPDATE_CURRENT_ALLERGIES_ERROR";
export const CreateCurrentAllergies = "CREATE_CURRENT_ALLERGIES";
export const CreateCurrentAllergiesSuccess = "CREATE_CURRENT_ALLERGIES_SUCCESS";
export const CreateCurrentAllergiesError = "CREATE_CURRENT_ALLERGIES_ERROR";
export const DeleteCurrentAllergies = "DELETE_CURRENT_ALLERGIES";
export const DeleteCurrentAllergiesSuccess = "DELETE_CURRENT_ALLERGIES_SUCCESS";
export const DeleteCurrentAllergiesError = "DELETE_CURRENT_ALLERGIES_ERROR";

export const GetAssessmentOutcome = "GET_ASSESSMENT_OUTCOME";
export const GetAssessmentOutcomeSuccess = "GET_ASSESSMENT_OUTCOME_SUCCESS";
export const GetAssessmentOutcomeError = "GET_ASSESSMENT_OUTCOME_ERROR";
export const UpdateAssessmentOutcome = "UPDATE_ASSESSMENT_OUTCOME";
export const UpdateAssessmentOutcomeSuccess = "UPDATE_ASSESSMENT_OUTCOME_SUCCESS";
export const UpdateAssessmentOutcomeError = "UPDATE_ASSESSMENT_OUTCOME_ERROR";
export const CreateAssessmentOutcome = "CREATE_ASSESSMENT_OUTCOME";
export const CreateAssessmentOutcomeSuccess = "CREATE_ASSESSMENT_OUTCOME_SUCCESS";
export const CreateAssessmentOutcomeError = "CREATE_ASSESSMENT_OUTCOME_ERROR";
export const SubmitAssessmentOutcome = "SUBMIT_ASSESSMENT_OUTCOME";
export const SubmitAssessmentOutcomeSuccess = "SUBMIT_ASSESSMENT_OUTCOME_SUCCESS";
export const SubmitAssessmentOutcomeError = "SUBMIT_ASSESSMENT_OUTCOME_ERROR";

export const GetLifestyleAdvice = "GET_LIFESTYLE_ADVICE";
export const GetLifestyleAdviceSuccess = "GET_LIFESTYLE_ADVICE_SUCCESS";
export const GetLifestyleAdviceError = "GET_LIFESTYLE_ADVICE_ERROR";
export const UpdateLifestyleAdvice = "UPDATE_LIFESTYLE_ADVICE";
export const UpdateLifestyleAdviceSuccess = "UPDATE_LIFESTYLE_ADVICE_SUCCESS";
export const UpdateLifestyleAdviceError = "UPDATE_LIFESTYLE_ADVICE_ERROR";
export const GetAdditionalSymptom = "GET_ADDITIONAL_SYMPTOM";
export const GetAdditionalSymptomSuccess = "GET_ADDITIONAL_SYMPTOM_SUCCESS";
export const GetAdditionalSymptomError = "GET_ADDITIONAL_SYMPTOM_ERROR";
export const UpdateAdditionalSymptom = "UPDATE_ADDITIONAL_SYMPTOM";
export const UpdateAdditionalSymptomSuccess = "UPDATE_ADDITIONAL_SYMPTOM_SUCCESS";
export const UpdateAdditionalSymptomError = "UPDATE_ADDITIONAL_SYMPTOM_ERROR";
export const GetMedicalAssessment = "GET_MEDICAL_ASSESSMENT";
export const GetMedicalAssessmentSuccess = "GET_MEDICAL_ASSESSMENT_SUCCESS";
export const GetMedicalAssessmentError = "GET_MEDICAL_ASSESSMENT_ERROR";
export const UpdateSymptomAdvice = "UPDATE_SYMPTOM_ADVICE";
export const UpdateSymptomAdviceSuccess = "UPDATE_SYMPTOM_ADVICE_SUCCESS";
export const UpdateSymptomAdviceError = "UPDATE_SYMPTOM_ADVICE_ERROR";

export const GetMedicalTriageClassification = "GET_MEDICAL_TRIAGE_CLASSIFICATION";
export const GetMedicalTriageClassificationSuccess = "GET_MEDICAL_TRIAGE_CLASSIFICATION_SUCCESS";
export const GetMedicalTriageClassificationError = "GET_MEDICAL_TRIAGE_CLASSIFICATION_ERROR";
export const GetMedicalTriageClassificationSchema = "GET_MEDICAL_TRIAGE_CLASSIFICATION_SCHEMA";
export const GetMedicalTriageClassificationSchemaSuccess =
  "GET_MEDICAL_TRIAGE_CLASSIFICATION_SCHEMA_SUCCESS";
export const GetMedicalTriageClassificationSchemaError =
  "GET_MEDICAL_TRIAGE_CLASSIFICATION_SCHEMA_ERROR";
export const UpdateMedicalTriageClassification = "UPDATE_MEDICAL_TRIAGE_CLASSIFICATION";
export const SubmitMedicalTriageClassification = "SUBMIT_MEDICAL_TRIAGE_CLASSIFICATION";
export const SubmitMedicalTriageClassificationSuccess =
  "SUBMIT_MEDICAL_TRIAGE_CLASSIFICATION_SUCCESS";
export const SubmitMedicalTriageClassificationError = "SUBMIT_MEDICAL_TRIAGE_CLASSIFICATION_ERROR";

export const CreateReasonAndDuration = "CREATE_REASON_END_DURATION";
export const CreateReasonAndDurationSuccess = "CREATE_REASON_END_DURATION_SUCCESS";
export const CreateReasonAndDurationError = "CREATE_REASON_END_DURATION_ERROR";
export const CreateQuery = "CREATE_QUERY";
export const CreateQuerySuccess = "CREATE_QUERY_SUCCESS";
export const CreateQueryError = "CREATE_QUERY_ERROR";
export const GetAbsenceReasonAndDurationSchema = "GET_ABSENCE_REASON_AND_DURATION_SCHEMA";
export const GetAbsenceReasonAndDurationSchemaSuccess =
  "GET_ABSENCE_REASON_AND_DURATION_SCHEMA_SUCCESS";
export const GetAbsenceReasonAndDurationSchemaError =
  "GET_ABSENCE_REASON_AND_DURATION_SCHEMA_ERROR";
export const GetAbsenceLandingSchema = "GET_ABSENCE_LANDING_SCHEMA";
export const GetAbsenceLandingSchemaSuccess = "GET_ABSENCE_LANDING_SCHEMA_SUCCESS";
export const GetAbsenceLandingSchemaError = "GET_ABSENCE_LANDING_SCHEMA_ERROR";
export const AssignCallInteractionNotes = "ASSIGN_CALL_INTERACTION_NOTES";
export const AssignCallInteractionNotesSuccess = "ASSIGN_CALL_INTERACTION_NOTES_SUCCESS";
export const AssignCallInteractionNotesError = "ASSIGN_CALL_INTERACTION_NOTES_ERROR";
export const GetEmployeePositions = "GET_EMPLOYEE_POSITIONS";
export const GetEmployeePositionsSuccess = "GET_EMPLOYEE_POSITIONS_SUCCESS";
export const GetEmployeePositionsError = "GET_EMPLOYEE_POSITIONS_ERROR";
export const SetShiftPatternAnswers = "SET_SHIFT_PATTERN_ANSWERS";
export const GenerateTimeLostPattern = "GENERATE_TIME_LOST_PATTERN";
export const RepeatTimeLostPattern = "REPEAT_TIME_LOST_PATTERN";
export const GetAbsenceTimeLostSchema = "GET_ABSENCE_TIME_LOST_SCHEMA";
export const GetAbsenceTimeLostSchemaSuccess = "GET_ABSENCE_TIME_LOST_SCHEMA_SUCCESS";
export const GetAbsenceTimeLostSchemaError = "GET_ABSENCE_TIME_LOST_SCHEMA_ERROR";
export const AssignAbsenceTimeLost = "ASSIGN_ABSENCE_TIME_LOST";
export const AssignAbsenceTimeLostSuccess = "ASSIGN_ABSENCE_TIME_LOST_SUCCESS";
export const AssignAbsenceTimeLostError = "ASSIGN_ABSENCE_TIME_LOST_ERROR";

export const SetNurseTransferDecision = "SET_NURSE_TRANSFER_DECISION";
export const CreateNurseTransferOffer = "CREATE_NURSE_TRANSFER_OFFER";
export const CreateNurseTransferOfferSuccess = "CREATE_NURSE_TRANSFER_OFFER_SUCCESS";
export const CreateNurseTransferOfferError = "CREATE_NURSE_TRANSFER_OFFER_ERROR";
export const GetNurseTransferOfferSchema = "GET_NURSE_TRANSFER_OFFER_SCHEMA";
export const GetNurseTransferOfferSchemaSuccess = "GET_NURSE_TRANSFER_OFFER_SCHEMA_SUCCESS";
export const GetNurseTransferOfferSchemaError = "GET_NURSE_TRANSFER_OFFER_SCHEMA_ERROR";
export const CloseAbsence = "CLOSE_ABSENCE";
export const CloseAbsenceSuccess = "CLOSE_ABSENCE_SUCCESS";
export const CloseAbsenceError = "CLOSE_ABSENCE_ERROR";
export const CloseAbsenceModalToggle = "CLOSE_ABSENCE_MODAL_TOGGLE";

export const GetCallInteractionDynamicQuestions = "GET_CALL_INTERACTION_DYNAMIC_QUESTIONS";
export const GetCallInteractionDynamicQuestionsSuccess =
  "GET_CALL_INTERACTION_DYNAMIC_QUESTIONS_SUCCESS";
export const GetCallInteractionDynamicQuestionsError =
  "GET_CALL_INTERACTION_DYNAMIC_QUESTIONS_ERROR";
export const GetCallInteractionReferralQuestions = "GET_CALL_INTERACTION_REFERRAL_QUESTIONS";
export const PutCallInteractionReferral = "PUT_CALL_INTERACTION_REFERRAL";
export const GetCallInteractionReferralQuestionsSuccess =
  "GET_CALL_INTERACTION_REFERRAL_QUESTIONS_SUCCESS";
export const PutCallInteractionReferralQuestionsSuccess =
  "PUT_CALL_INTERACTION_REFERRAL_QUESTIONS_SUCCESS";
export const GetCallInteractionReferralQuestionsError =
  "GET_CALL_INTERACTION_REFERRAL_QUESTIONS_ERROR";
export const SetCallInteractionReferralQuestionsValid =
  "ON_SET_CALL_INTERACTION_REFERRAL_QUESTIONS_VALID";

export const GetCallInteractionStandardQuestions = "GET_CALL_INTERACTION_STANDARD_QUESTIONS";
export const GetCallInteractionStandardQuestionsSuccess =
  "GET_CALL_INTERACTION_STANDARD_QUESTIONS_SUCCESS";
export const GetCallInteractionStandardQuestionsError =
  "GET_CALL_INTERACTION_STANDARD_QUESTIONS_ERROR";
export const AssignStandardQuestionAnswers = "ASSIGN_STANDARD_QUESTION_ANSWERS";
export const AssignStandardQuestionAnswersSuccess = "ASSIGN_STANDARD_QUESTION_ANSWERS_SUCCESS";
export const AssignStandardQuestionAnswersError = "ASSIGN_STANDARD_QUESTION_ANSWERS_ERROR";
export const AssignDynamicQuestionAnswers = "ASSIGN_DYNAMIC_QUESTION_ANSWERS";
export const AssignDynamicQuestionAnswersSuccess = "ASSIGN_DYNAMIC_QUESTION_ANSWERS_SUCCESS";
export const AssignDynamicQuestionAnswersError = "ASSIGN_DYNAMIC_QUESTION_ANSWERS_ERROR";

export const SetUpdateShiftPatternTimeLost = "SET_UPDATE_SHIFT_PATTERN_TIME_LOST";
export const UpdateEmployeeDetailsData = "UPDATE_EMPLOYEE_DETAILS_DATA";

// Nurse Transfer
export const GetAvailableNurseAdvisors = "GET_AVAILABLE_NURSE_ADVISORS";
export const GetAvailableNurseAdvisorsSuccess = "GET_AVAILABLE_NURSE_ADVISORS_SUCCESS";
export const GetAvailableNurseAdvisorsError = "GET_AVAILABLE_NURSE_ADVISORS_ERROR";
export const SetSelectedNurseAdvisor = "SET_SELECTED_NURSE_ADVISOR";
export const AssignEmployeeToNurseAdvisor = "ASSIGN_EMPLOYEE_TO_NURSE_ADVISORS";
export const AssignEmployeeToNurseAdvisorSuccess = "ASSIGN_EMPLOYEE_TO_NURSE_ADVISORS_SUCCESS";
export const AssignEmployeeToNurseAdvisorError = "ASSIGN_EMPLOYEE_TO_NURSE_ADVISORS_ERROR";
export const DeassignEmployeeToNurseAdvisor = "DEASSIGN_EMPLOYEE_TO_NURSE_ADVISORS";
export const DeassignEmployeeToNurseAdvisorSuccess = "DEASSIGN_EMPLOYEE_TO_NURSE_ADVISORS_SUCCESS";
export const DeassignEmployeeToNurseAdvisorError = "DEASSIGN_EMPLOYEE_TO_NURSE_ADVISORS_ERROR";
export const GetIncomingNurseTransfer = "GET_INCOMING_NURSE_TRANSFER";
export const GetIncomingNurseTransferSuccess = "GET_INCOMING_NURSE_TRANSFER_SUCCESS";
export const GetIncomingNurseTransferError = "GET_INCOMING_NURSE_TRANSFER_ERROR";
export const AcceptNurseTransfer = "ACCEPT_INCOMING_NURSE_TRANSFER";
export const AcceptNurseTransferSuccess = "ACCEPT_INCOMING_NURSE_TRANSFER_SUCCESS";
export const AcceptNurseTransferError = "ACCEPT_INCOMING_NURSE_TRANSFER_ERROR";

export const AssignTransferLanding = "ASSIGN_TRANSFER_LANDING";
export const AssignTransferLandingSuccess = "ASSIGN_TRANSFER_LANDING_SUCCESS";
export const AssignTransferLandingError = "ASSIGN_TRANSFER_LANDING_ERROR";

export const GetClientInformation = "GET_CLIENT_INFORMATION";
export const GetClientInformationSuccess = "GET_CLIENT_INFORMATION_SUCCESS";
export const GetClientInformationError = "GET_CLIENT_INFORMATION_ERROR";

export const ClientInformationExport = "CLIENT_INFORMATION_EXPORT";
export const ClientInformationExportSuccess = "CLIENT_INFORMATION_EXPORT_SUCCESS";
export const ClientInformationExportError = "CLIENT_INFORMATION_EXPORT_ERROR";

export const RestoreCallback = "RESTORE_CALLBACK";
export const RestoreCallbackSuccess = "RESTORE_CALLBACK_SUCCESS";
export const RestoreCallbackError = "RESTORE_CALLBACK_ERROR";

export const PostSettingTheSceneText = "POST_SETTING_THE_SCENE_TEXT";
export const PostSettingTheSceneTextSuccess = "POST_SETTING_THE_SCENE_TEXT_SUCCESS";
export const PostSettingTheSceneTextError = "POST_SETTING_THE_SCENE_TEXT_ERROR";

export const PutSettingTheSceneText = "PUT_SETTING_THE_SCENE_TEXT";
export const PutSettingTheSceneTextSuccess = "PUT_SETTING_THE_SCENE_TEXT_SUCCESS";
export const PutSettingTheSceneTextError = "PUT_SETTING_THE_SCENE_TEXT_ERROR";

export const GetSettingTheSceneText = "GET_SETTING_THE_SCENE_TEXT";
export const GetSettingTheSceneTextSuccess = "GET_SETTING_THE_SCENE_TEXT_SUCCESS";
export const GetSettingTheSceneTextError = "GET_SETTING_THE_SCENE_TEXT_ERROR";

export const CreateNewAbsence = "CREATE_NEW_ABSENCE";
export const CreateNewAbsenceSuccess = "CREATE_NEW_ABSENCE_SUCCESS";
export const CreateNewAbsenceError = "CREATE_NEW_ABSENCE_ERROR";
export const UpdateExistingAbsence = "UPDATE_EXISTING_ABSENCE";
export const UpdateExistingAbsenceSuccess = "UPDATE_EXISTING_ABSENCE_SUCCESS";
export const UpdateExistingAbsenceError = "UPDATE_EXISTING_ABSENCE_ERROR";
export const AddAdditionalInfo = "ADD_ADDITIONAL_INFO";

export const GetMedicalTriageHistory = "GET_MEDICAL_TRIAGE_HISTORY";
export const GetMedicalTriageHistorySuccess = "GET_MEDICAL_TRIAGE_HISTORY_SUCCESS";
export const GetMedicalTriageHistoryError = "GET_MEDICAL_TRIAGE_HISTORY_ERROR";
export const GetMedicalTriageDetails = "GET_MEDICAL_TRIAGE_DETAILS";
export const GetMedicalTriageDetailsSuccess = "GET_MEDICAL_TRIAGE_DETAILS_SUCCESS";
export const GetMedicalTriageDetailsError = "GET_MEDICAL_TRIAGE_DETAILS_ERROR";

export const GetJobDuties = "GET_JOB_DUTIES";
export const GetJobDutiesSuccess = "GET_JOB_DUTIES_SUCCESS";
export const GetJobDutiesError = "GET_JOB_DUTIES_ERROR";

export const GetQuestionsAndAnswers = "GET_QUESTIONS_AND_ANSWERS";
export const GetQuestionsAndAnswersSuccess = "GET_QUESTIONS_AND_ANSWERS_SUCCESS";
export const GetQuestionsAndAnswersError = "GET_QUESTIONS_AND_ANSWERS_ERROR";
